module.exports = __webpack_public_path__ + "img/HQ-PA2W1L_ALL.ef1f6b81.jpg";